'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { type DocumentoPadrao, recusaDoUsoDocumentoPadrao, useUsoDocumentoPadraoComChave } from '@/features/documentosPadrao';
import { useToast } from '@/shared/providers';
import { useAppDispatch } from '@/store/hooks';
import { juntarDocumentoPadraoArbitral } from '../store/actions';

/**
 * O `onConfirmar` do painel "Buscar documento padrão" na aba Documentos: junta a versão conferida
 * aos autos e só resolve depois de a juntada persistir e as abas recarregarem. A chave idempotente
 * por documento+versão vem de `useUsoDocumentoPadraoComChave`, a mesma do cadastro.
 *
 * @example const usarDocumentoPadrao = useJuntarDocumentoPadrao(processoId)
 */
export function useJuntarDocumentoPadrao(processoId) {
  const $ = _c(4);
  const dispatch = useAppDispatch();
  const toast = useToast();
  let t0;
  if ($[0] !== dispatch || $[1] !== processoId || $[2] !== toast) {
    t0 = async (documento, clientRequestId) => {
      const resultado = await dispatch(juntarDocumentoPadraoArbitral({
        processoId,
        documentoPadraoId: documento.id,
        versao: documento.versaoAtual,
        clientRequestId
      }));
      if (juntarDocumentoPadraoArbitral.rejected.match(resultado)) {
        throw resultado.payload ?? recusaDoUsoDocumentoPadrao(resultado.error, {});
      }
      toast.showSuccess("Documento juntado", `${documento.nome} foi juntado aos autos do processo.`);
    };
    $[0] = dispatch;
    $[1] = processoId;
    $[2] = toast;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const juntar = t0;
  return useUsoDocumentoPadraoComChave(processoId, juntar);
}